export default __webpack_public_path__ + "static/media/012-gorilla.8fc34f08.svg";